export default __webpack_public_path__ + "3bf91a40f8e39beab3309a5149fed1e3.ttf";